import { useMutation } from '@apollo/client';

import { PAYMENT_RESULT_CODE } from '../paymentTypeDefs';

export const useMutationPaymentResultCode = (): any => (
  useMutation(PAYMENT_RESULT_CODE)
);
